import * as Yup from 'yup'

export const getInitialValues = (shopCodes, shopTypes) => {
  return {
    shopCodes: [],
    file: null,
    ruleTypes: []
  }
}
